module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('i', [_vm._v("The naked gospel [is] discovering what was the gospel"), _c('br'), _vm._v("which our Lord and his apostles preached; what additions"), _c('br'), _vm._v("and alterations latter ages have made in it;"), _c('br'), _vm._v("what advantages and damages have thereupon ensued.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Arthur Bury, 1691")]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image1"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image 1",
      "src": "images/01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Arthur Bury’s book titled "), _c('i', [_vm._v("The Naked Gospel")]), _c('br'), _vm._v("was burned by the church of his day.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a4a963b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008excerpt.vue
// module id = 75
// module chunks = 0